export default __webpack_public_path__ + "static/rovo-cues-dark-96651f85aed4a852868a611ecacbf38c7f75ca4afa54589f478797a9dc788fc1.png";